import React, {useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Input from "@amzn/meridian/input";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import {LidarOverviewContext} from "../context/LidarOverviewContext";
import Alert from "@amzn/meridian/alert"
import {
    MAC_MASK,
    isValidEntry,
    IP_ADDRESS_PATTERN,
    PATTERNS,
    SCANLESS_SUPPORTED_CART_RECIPES_NA,
    SCANLESS_SUPPORTED_CART_RECIPES_EU,
    validateNewLidarController,
    SCANLESS_SUPPORTED_CART_RECIPES_JP, LIDAR_CONTROLLER_TYPES,
} from "../../../util/Validations";
import {getUTRRegion} from "../../../util/Util";
import {GlobalStateContext} from "../../../global/context/GlobalStateContext";
import Select, {SelectOption} from "@amzn/meridian/select";

const AddEditSingleLidarControllerModal = (props) => {

    const {formatMessage} = props.intl;
    const {open, setOpen, selected, setSelected} = props;
    const {showWarning} = useContext(GlobalStateContext);
    const {viewModel, dispatch} = useContext(LidarOverviewContext);

    // Visual controls
    const [showAlert, setShowAlert] = useState(false)

    // States
    const [ip, setIp] = useState(null)
    const [mac, setMac] = useState(null)
    const [startAisle, setStartAisle] = useState(null)
    const [endAisle, setEndAisle] = useState(null);
    const [nonOVCartRecipe, setNonOVCartRecipe] = useState(null);
    const [oneTierOVCartRecipe, setOneTierOVCartRecipe] = useState(null);
    const [twoTierOVCartRecipe, setTwoTierOVCartRecipe] = useState(null);
    const [creationTime, setCreationTime] = useState(null);
    const [lidarControllerType, setLidarControllerType] = useState(null);

    // Error
    const [ipErr, setIpErr] = useState(false)
    const [macErr, setMacErr] = useState(false)
    const [startAisleErr, setStartAisleErr] = useState(false)
    const [endAisleErr, setEndAisleErr] = useState(false);
    const [nonOVCartRecipeErr, setNonOVCartRecipeErr] = useState(false);
    const [oneTierOVCartRecipeErr, setOneTierOVCartRecipeErr] = useState(false);
    const [twoTierOVCartRecipeErr, setTwoTierOVCartRecipeErr] = useState(false);
    const [lidarControllerTypeErr, setLidarControllerTypeErr] = useState(false);
    const {showCustomAlert} = useContext(GlobalStateContext);

    const stateValues = {
        lidarControllerConfig: {
            lidarControllerType: lidarControllerType,
            macAddress: mac,
            ipAddress: ip,
            startAisleLabel: startAisle,
            endAisleLabel: endAisle,
            nonOVCartRecipe: nonOVCartRecipe,
            oneTierOVCartRecipe: oneTierOVCartRecipe,
            twoTierOVCartRecipe: twoTierOVCartRecipe,
            creationTime: creationTime,
        }
    }

    const onCloseModal = () => {
        setOpen(false)
        setSelected(null);
        resetInputState();
        setShowAlert(false);
    }
    const onClickConfirm = (stateValues) => {
        if (validateNewLidarController(stateValues)) {
            showWarning(formatMessage({id: "lidarController.editWarning"}), () => {
                setShowAlert(false)
                if (selected) {
                    updateData(stateValues);
                } else {
                    addData(stateValues);
                }
                resetInputState();
                setOpen(false);
            });
        } else {
            setShowAlert(true)
        }
    }

    function resetInputState() {
        // setting state of input fields as empty to have empty inputs on clicking Add Device again
        setMac(null);
        setMacErr(false);
        resetAssetDetails();
        resetAssetDetailErrors();
    }

    const resetAssetDetails = () => {
        setLidarControllerType(null);
        setIp(null);
        setStartAisle(null);
        setEndAisle(null);
        setNonOVCartRecipe(null);
        setOneTierOVCartRecipe(null);
        setTwoTierOVCartRecipe(null);
        setCreationTime(null);
    }

    const resetAssetDetailErrors = () => {
        setLidarControllerTypeErr(false);
        setIpErr(false);
        setStartAisleErr(false);
        setEndAisleErr(false);
        setNonOVCartRecipeErr(false);
        setOneTierOVCartRecipeErr(false);
        setTwoTierOVCartRecipeErr(false);
    }

    const prefill = (value) => {
        if (viewModel.lidarDeviceInformation && viewModel.lidarDeviceInformation.hasOwnProperty(value)) {
            setSelected(value);
            const device = viewModel.lidarDeviceInformation[value];
            resetAssetDetailErrors();
            setLidarControllerType(device.lidarControllerType)
            setMac(device.mac)
            setIp(device.ip);
            setStartAisle(device.startAisleLabel);
            setEndAisle(device.endAisleLabel);
            setNonOVCartRecipe(device.nonOvColumnType);
            setOneTierOVCartRecipe(device.oneTierOvColumnType);
            setTwoTierOVCartRecipe(device.twoTierOvColumnType);
            setCreationTime(device.creationTime);
        } else if (!selected) {
            resetAssetDetails();
        }
    }

    const addData = (stateValues) => {
        dispatch({
            type: 'ADD_LIDAR_CONTROLLER', data: {
                dispatcher: dispatch, stateValues: stateValues,
                showCustomAlert: showCustomAlert
            }
        })
    }
    const updateData = (stateValues) => {
        dispatch({
            type: 'UPDATE_LIDAR_CONTROLLER', data: {
                dispatcher: dispatch, stateValues: stateValues,
                showCustomAlert: showCustomAlert
            }
        })
    }

    const generateCartTypesSelectOptions = (cartTypes) => {
        return (
            cartTypes.map((cartType) =>
                <SelectOption key={cartType}
                              value={cartType}
                              label={viewModel.cartRecipesMap
                              && viewModel.cartRecipesMap.has(cartType)
                              && viewModel.cartRecipesMap.get(cartType).displayName
                                  ? viewModel.cartRecipesMap.get(cartType).displayName : cartType} />))
    }

    return (
        <Modal
            title={formatMessage({id: "device.add_device_button_modal"})}
            open={open}
            onOpen={() => prefill(selected)}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium"
            width="100%">
            <Column spacing={"medium"} spacingInset={"medium"}>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="lidar-controller-type-input">
                        <FormattedMessage id="device.controller_type" defaultMessage="Controller Type"/>
                    </Text>
                    <Select id="lidar-controller-type-input"
                           value={lidarControllerType}
                           onChange={setLidarControllerType}
                           placeholder={<FormattedMessage id="modal.selectLidarControllerType" defaultMessage="Select Lidar Controller Type"/>}
                           onBlur={() => setLidarControllerTypeErr(!lidarControllerType)}
                           error={lidarControllerTypeErr}>
                        { LIDAR_CONTROLLER_TYPES.map(value => <SelectOption key={value} value={value} label={value}/>)
                        }
                    </Select>
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="mac-input">
                        <FormattedMessage id="modal.mac" defaultMessage="MAC Address"/>
                    </Text>
                    <Input id="mac-input"
                           value={mac}
                           onChange={setMac}
                           mask={MAC_MASK}
                           disabled={selected}
                           onBlur={() => {
                               setMacErr(!isValidEntry(stateValues.lidarControllerConfig.macAddress, PATTERNS.MAC))
                               prefill(mac);
                           }}
                           error={macErr}
                    />
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="ip-input">
                        <FormattedMessage id="modal.ip" defaultMessage="IP Address"/>
                    </Text>
                    <Input id="ip-input"
                           value={ip}
                           onChange={setIp}
                           onBlur={() => setIpErr(!isValidEntry(stateValues.lidarControllerConfig.ipAddress, IP_ADDRESS_PATTERN))}
                           error={ipErr}
                    />
                </Column>
                {/*TODO: Add Aisle validation by getting list of aisles from NARC*/}
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="start-aisle-input">
                        <FormattedMessage id="modal.startAisle" defaultMessage="Start Aisle"/>
                    </Text>
                    <Input id="start-aisle-input"
                           value={startAisle}
                           onChange={setStartAisle}
                           onBlur={() => setStartAisleErr(!isValidEntry(stateValues.lidarControllerConfig.startAisleLabel, PATTERNS.AISLE))}
                           error={startAisleErr}
                    />
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="end-aisle-input">
                        <FormattedMessage id="modal.endAisle" defaultMessage="End Aisle"/>
                    </Text>
                    <Input id="end-aisle-input"
                           value={endAisle}
                           onChange={setEndAisle}
                           onBlur={() => setEndAisleErr(!isValidEntry(stateValues.lidarControllerConfig.endAisleLabel, PATTERNS.AISLE))}
                           error={endAisleErr}
                    />
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="nonov-cart-recipe-input">
                        <FormattedMessage id="modal.nonOVCartRecipe"
                                          defaultMessage="Non OV Column Type"/>
                    </Text>
                    <Select id="nonov-cart-recipe-input"
                            value={nonOVCartRecipe}
                            onChange={(value) => setNonOVCartRecipe(value)}
                            onBlur={() => setNonOVCartRecipeErr(!nonOVCartRecipe)}
                            placeholder={<FormattedMessage id="modal.selectNonOVCartRecipe" defaultMessage="Select Non OV Column Type"/>}
                            error={nonOVCartRecipeErr}
                            width="100%">

                        {
                            getUTRRegion() === "NA" ? generateCartTypesSelectOptions(SCANLESS_SUPPORTED_CART_RECIPES_NA.NON_OV)
                            : getUTRRegion() === "EU" ? generateCartTypesSelectOptions(SCANLESS_SUPPORTED_CART_RECIPES_EU.NON_OV)
                            : generateCartTypesSelectOptions(SCANLESS_SUPPORTED_CART_RECIPES_JP.NON_OV)
                        }
                    </Select>
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="2tier-ov-cart-recipe-input">
                        <FormattedMessage id="modal.2tierOVCartRecipe"
                                          defaultMessage="2 Tier OV column type"/>
                    </Text>
                    <Select id="2tier-ov-cart-recipe-input"
                            value={twoTierOVCartRecipe}
                            onChange={(value) => setTwoTierOVCartRecipe(value)}
                            onBlur={() => setTwoTierOVCartRecipeErr(!twoTierOVCartRecipe)}
                            placeholder={<FormattedMessage id="modal.select2tierOVCartRecipe" defaultMessage="Select 2 Tier OV column type"/>}
                            error={twoTierOVCartRecipeErr}
                            width="100%">

                        {
                            getUTRRegion() === "NA" ? generateCartTypesSelectOptions(SCANLESS_SUPPORTED_CART_RECIPES_NA.TWO_TIER_OV)
                                : getUTRRegion() === "EU" ? generateCartTypesSelectOptions(SCANLESS_SUPPORTED_CART_RECIPES_EU.TWO_TIER_OV)
                                    : generateCartTypesSelectOptions(SCANLESS_SUPPORTED_CART_RECIPES_JP.TWO_TIER_OV)
                        }
                    </Select>
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="1tier-ov-cart-recipe-input">
                        <FormattedMessage id="modal.1tierOVCartRecipe"
                                          defaultMessage="1 Tier OV Column Type"/>
                    </Text>
                    <Select id="1tier-ov-cart-recipe-input"
                            value={oneTierOVCartRecipe}
                            onChange={(value) => setOneTierOVCartRecipe(value)}
                            placeholder={<FormattedMessage id="modal.select1tierOVCartRecipe" defaultMessage="Select 1 Tier OV Column Type"/>}
                            error={oneTierOVCartRecipeErr}
                            width="100%">

                        {
                            getUTRRegion() === "NA" ? generateCartTypesSelectOptions(SCANLESS_SUPPORTED_CART_RECIPES_NA.ONE_TIER_OV)
                                : getUTRRegion() === "EU" ? generateCartTypesSelectOptions(SCANLESS_SUPPORTED_CART_RECIPES_EU.ONE_TIER_OV)
                                    : generateCartTypesSelectOptions(SCANLESS_SUPPORTED_CART_RECIPES_JP.ONE_TIER_OV)
                        }
                    </Select>
                </Column>
            </Column>
            {<ModalFooter>
            <Column>
                {showAlert && <Alert type="warning" size="small">
                    <FormattedMessage id="alert.missingfields"
                                      defaultMessage="Please enter all fields in correct format!"/>
                </Alert>}
            </Column>
            <Row alignmentHorizontal="right" widths="fit">
                <Button type="secondary" size="medium" onClick={onCloseModal}>
                    <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                </Button>
                <Button type="primary"
                        size="medium"
                        onClick={() => onClickConfirm(stateValues)}>
                    {selected ? <FormattedMessage id="modal.confirmEdit" defaultMessage="Confirm edit"/> :
                        <FormattedMessage id="modal.confirmAdd" defaultMessage="Confirm add"/>
                    }
                </Button>
            </Row>
        </ModalFooter>}
        </Modal>
    )
}

export default injectIntl(AddEditSingleLidarControllerModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/modal/AddEditSingleLidarControllerModal.js